import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import ApiEncrypt from 'src/Member/utils/Encrypt';

const useAccountUnlockSuccess = () => {
  const location = useLocation();
  const { encryptData } = ApiEncrypt();
  const headingRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState(false);
  const data = location?.state?.data;
  const password = location?.state?.newPassword;
  const OTPRequired = location?.state?.OTPRequired;
  const forcePassword = location?.state?.forcePassword;

  const updateUser = async () => {
    setIsLoading(true);
    try {
      const newPassword = forcePassword
        ? {
            Password: encryptData(password, false),
          }
        : {};
      const updateUserPayload = {
        UpdateUser: {
          Oid: data?.Oid,
          UserType: data?.UserType,
          UserID: data?.UserEmail,
          Status: 'Active',
          FlowName: 'Unlock Account',
          ...newPassword,
        },
      };
      const response = await axiosInstance.put(
        APIEndpoints.UpdateUserResource(),
        updateUserPayload,
      );
    } catch (e) {
      setIsLoading(false);
      setServerError(true);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    updateUser();
  }, []);
  useEffect(() => {
    if (headingRef.current) {
      headingRef.current.focus();
    }
  }, [isLoading, serverError]);
  return {
    isLoading,
    serverError,
    headingRef,
  };
};

export default useAccountUnlockSuccess;
